module.exports = __webpack_public_path__ + "static/img/a081.0ceb568.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a081.jpg
// module id = YPh/
// module chunks = 0